import React, {useEffect, useState} from "react";
import Navbar from "../../components/Enrollment/Navbar";
import '../../utils/Style/pages/enrollment.scss';
import FormsTemplate from "./FormsTemplate";
import Stepper from "../../components/Enrollment/Stepper";
import MerchantFormsTemplate from "./MerchantFormsTemplate";
import {useNavigate, useParams} from "react-router-dom";
import useLogout from "../../api/logoutApi";

function Enrollment({entity}) {
    const [currentStep, setCurrentStep] = useState(1);
    const totalSteps = entity === "legal" ? 3 : 6;
    const [visited, setVisited] = useState([]);

    const {logout} = useLogout();

    useEffect(() => {
        if (!sessionStorage.getItem("SessionID")) {
            logout();
        }
    }, []);

    const steps = entity === "legal" ? [
        {step: 1, description: "Company Information"},
        {step: 2, description: "Employees Information"},
        {step: 3, description: "Confirm & Done"}
    ] : [
        {step: 1, description: "Merchant Information"},
        {step: 2, description: "Merchant Profile"},
        {step: 3, description: "Payment Information"},
        {step: 4, description: "Admin"},
        {step: 5, description: "Done"}
    ]

    const {step} = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (parseInt(step) === totalSteps){
            setVisited([...visited, parseInt(step)-1]);
        }

        if (step && visited.includes(parseInt(step)-1)) {
            setCurrentStep(parseInt(totalSteps));
        }else
        if (visited.includes(totalSteps-1)) {
            setCurrentStep(totalSteps);
        }
        else {
            navigate(`/merchant-enrollment/${currentStep}`);
        }
    }, [step]);

    const handleNext = () => {
        if (currentStep < totalSteps) {
            navigate(`/merchant-enrollment/${currentStep + 1}`);
            setCurrentStep(currentStep + 1);
        }
    };

    return (
        <div className="enrollment">
            <Navbar/>
            {currentStep !== 6 &&
                <Stepper
                    currentStep={currentStep}
                    steps={steps}
                    setSteps={setCurrentStep}
                    setCurrentStep={setCurrentStep}
                    visited={visited}
                    setVisited={setVisited}
                />
            }

            {entity === "legal" &&
                <FormsTemplate handleNext={handleNext} currentStep={currentStep}/>
            }
            {entity === "merchant" &&
                <MerchantFormsTemplate handleNext={handleNext} currentStep={currentStep}/>
            }
        </div>
    );
}

export default Enrollment;